import { FileMap, MessageTypes } from './types';

export function getXmatCaseFiles(xmatCaseId: string): FileMap {
  if (!xmatCaseId?.trim()) {
    return {};
  }

  return {
    screen: {
      id: `Screen${xmatCaseId}`,
      fileName: `Screen${xmatCaseId}`,
      displayName: `Latest Screen for Case ID ${xmatCaseId}`,
      messageType: MessageTypes.xmatScreen,
      size: 0,
      sentTime: '',
      memberId: 0,
    },
    trends: {
      id: `Trends${xmatCaseId}`,
      fileName: `Trends${xmatCaseId}`,
      displayName: `Latest Trends File for Case ID ${xmatCaseId}`,
      messageType: MessageTypes.xmatTrends,
      size: 0,
      sentTime: '',
      memberId: 0,
    },
    history: {
      id: `History${xmatCaseId}`,
      fileName: `History${xmatCaseId}`,
      displayName: `Latest History for Case ID ${xmatCaseId}`,
      messageType: MessageTypes.xmatHistory,
      size: 0,
      sentTime: '',
      memberId: 0,
    },
    admin: {
      id: `Admin${xmatCaseId}`,
      fileName: `Admin${xmatCaseId}`,
      displayName: `Case Sum Admin for ID ${xmatCaseId}`,
      messageType: MessageTypes.xmatAdmin,
      size: 0,
      sentTime: '',
      memberId: 0,
    },
    notes: {
      id: `Notes${xmatCaseId}`,
      fileName: `Notes${xmatCaseId}`,
      displayName: `Case Sum Notes for ID ${xmatCaseId}`,
      messageType: MessageTypes.xmatNotes,
      size: 0,
      sentTime: '',
      memberId: 0,
    },
    sumext: {
      id: `SumExt${xmatCaseId}`,
      fileName: `SumExt${xmatCaseId}`,
      displayName: `Case Sum Ext Measures for ID ${xmatCaseId}`,
      messageType: MessageTypes.xmatSumExt,
      size: 0,
      sentTime: '',
      memberId: 0,
    },
    sumint: {
      id: `SumInt${xmatCaseId}`,
      fileName: `SumInt${xmatCaseId}`,
      displayName: `Case Sum Int Measures for ID ${xmatCaseId}`,
      messageType: MessageTypes.xmatSumInt,
      size: 0,
      sentTime: '',
      memberId: 0,
    },
    casesum: {
      id: `CaseSum${xmatCaseId}`,
      fileName: `CaseSum${xmatCaseId}`,
      displayName: `Case Sum All for ID ${xmatCaseId}`,
      messageType: MessageTypes.xmatCaseSum,
      size: 0,
      sentTime: '',
      memberId: 0,
    },
  };
}
